// extracted by mini-css-extract-plugin
module.exports = {"top":"HomepageBottom_top__2X-Bl","bottom":"HomepageBottom_bottom__31bQm"};